import { Box, Flex, Grid, GridItem, Image, Text, useColorMode } from "@chakra-ui/react";
import { ReactNode } from "react";
import { assets } from "../../assets/assets";

export const InviteNotice = ({ title, children }: { title: string; children: ReactNode }) => {
  const theme = useColorMode();
  return (
    <Box
      width="full"
      height="100vh"
      bgGradient="linear(to-br, smTealShadow, smBackground, smBackground, smBackground, smBlueShadow)"
    >
      <Grid
        gridTemplateColumns={"1fr minmax(0, 500px) 1fr"}
        height="100%"
        gridTemplateRows={"1fr minmax(200px, auto) 2fr"}
        templateAreas={`
            "left top right"
            "left login right"
            "left bottom right"
            `}
      >
        <GridItem area="left"></GridItem>
        <GridItem area="top"></GridItem>
        <GridItem area="bottom"></GridItem>
        <GridItem area="right"></GridItem>
        <GridItem area="login" borderRadius={10} boxShadow="0 9px 46px 8px rgb(0,0,0,0.2)" padding={10}>
          <Flex w="100%" h={"100%"} flexDirection="column">
            <Flex paddingTop={"20px"} paddingBottom="35px">
              <Image src={theme.colorMode === "dark" ? assets.logo_dark : assets.logo} alt="Logo" h="30px" mt="10px" />
            </Flex>
            <Text fontSize="2xl" mt="5px">
              <b>{title}</b>
            </Text>
            <Box mt="10px">{children}</Box>
          </Flex>
        </GridItem>
      </Grid>
    </Box>
  );
};
